import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["layout", "responsive", "theme"];
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!ecosystem-marketpla... Remove this comment to see the full error message
import calloutBlobsImageUrl from 'bender-url!marketplace-ui-common/img/callout-blobs.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!ecosystem-marketpla... Remove this comment to see the full error message
import calloutWaveImageUrl from 'bender-url!marketplace-ui-common/img/callout-wave.svg';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useMemo } from 'react';
import styled from 'styled-components';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { MediaQueryView } from '../../layout/components/MediaQueryView';
import { FEATURED_CALLOUT_COLORS } from '../constants/FeaturedCallouts';
import { GRID_BREAKPOINT_LARGE, GRID_BREAKPOINT_EXTRA_LARGE } from '../../layout/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WAVE_HEIGHT = 100;
const BLOB_LAYOUT_BREAKPOINTS = {
  FULL_WIDTH: GRID_BREAKPOINT_LARGE,
  MULTI: GRID_BREAKPOINT_EXTRA_LARGE
};
const calloutHeroGradient = ({
  primaryBackgroundColor,
  secondaryBackgroundColor
}) => `linear-gradient(-303deg, ${primaryBackgroundColor}, ${secondaryBackgroundColor})`;
const CalloutHero = styled.div.withConfig({
  displayName: "FeaturedCallout__CalloutHero",
  componentId: "gbm1xx-0"
})(["flex:1;position:relative;padding:", ";border-radius:inherit;overflow:hidden;background-color:", ";background-image:", " ", ";background-position:top right;background-repeat:no-repeat;background-size:auto 110%;&::after{content:'';display:block;height:", "px;width:110%;position:absolute;left:-5%;right:-5%;bottom:-", "px;background-image:url(", ");background-repeat:no-repeat;background-size:100% 100%;}", ""], ({
  theme
}) => `${theme.space['600']} ${theme.space['1000']} ${theme.space['1000']} ${theme.space['600']}`, props => props.primaryBackgroundColor, props => props.layout === 'FULL_WIDTH' ? `url(${calloutBlobsImageUrl}),` : '', calloutHeroGradient, WAVE_HEIGHT, WAVE_HEIGHT / 2, calloutWaveImageUrl, _ref => {
  let {
      layout,
      responsive,
      theme
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return responsive && `
    @media (max-width: ${GRID_BREAKPOINT_EXTRA_LARGE}) {
      padding: ${theme.space['600']} ${theme.space['600']} ${theme.space['1000']} ${theme.space['600']};
    }
    @media (max-width: ${BLOB_LAYOUT_BREAKPOINTS[layout]}) {
      background-image: ${calloutHeroGradient(rest)};
    }
  `;
});
export default function FeaturedCallout({
  buttonText,
  gradientColor,
  description,
  external,
  headline,
  href,
  illustrationName,
  onClick,
  layout = 'FULL_WIDTH',
  responsive = true
}) {
  const [primaryBackgroundColor, secondaryBackgroundColor] = useMemo(() => FEATURED_CALLOUT_COLORS[gradientColor], [gradientColor]);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    compact: true,
    children: [/*#__PURE__*/_jsx(CalloutHero, {
      layout: layout,
      primaryBackgroundColor: primaryBackgroundColor,
      secondaryBackgroundColor: secondaryBackgroundColor,
      responsive: responsive,
      children: /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          flex: "1",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h4",
            marginBlockEnd: "200",
            color: "text-core-on-fill-default",
            children: headline
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            color: "text-core-on-fill-default",
            children: description
          })]
        }), layout !== 'MULTI' && /*#__PURE__*/_jsx(MediaQueryView, {
          min: responsive ? 'md' : 'xs',
          children: /*#__PURE__*/_jsx(Flex, {
            justifyContent: "center",
            inlineSize: "272px",
            paddingInlineStart: "1100",
            children: /*#__PURE__*/_jsx(Illustration, {
              blockSize: "100%",
              maxBlockSize: "100px",
              minBlockSize: "72px",
              name: illustrationName,
              role: "presentation"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      paddingBlockStart: "0",
      children: external ? /*#__PURE__*/_jsx(Button, {
        external: external,
        href: href,
        onClick: onClick,
        size: "small",
        truncate: true,
        use: "tertiary",
        children: buttonText
      }) : /*#__PURE__*/_jsx(UIRouterButton, {
        onClick: onClick,
        size: "small",
        to: href,
        truncate: true,
        use: "tertiary",
        children: buttonText
      })
    })]
  });
}